<template>
  <div class="account">
    <section class="admin-account-container bg-white shadow-xl mt-10 mx-10 rounded-lg px-4 py-8">
      <h2 class="text-2xl text-center">{{ $t('My Account') }}</h2>

      <div class="w-full mt-6 text-center">
        <p class="mb-2 text-xl font-bold">{{ $t('Restaurant Name') }}:</p>
        <p class="mb-4 text-lg">{{ restaurantName }}</p>
        <p class="mb-2 text-xl font-bold">{{ $t('Email') }}:</p>
        <p class="mb-4 text-lg">{{ email }}</p>
        <p class="mb-2 text-xl font-bold">{{ $t('Phone') }}:</p>
        <p class="mb-4 text-lg">{{ phone }}</p>
        <p class="mb-2 text-xl font-bold">{{ $t('Address') }}:</p>
        <p class="mb-8 text-lg">{{ address }}</p>
        <button
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          @click="handleLogout"
        >
          {{ $t('Logout') }}
        </button>

      </div>

      <div class="w-full mb-10 mt-6 text-center">

        <p class="mb-2 text-xl font-bold">Mesonera:</p>
        <p class="mb-2 text-xl font-bold">{{ $t('Email') }}:</p>
        <p class="mb-4 text-lg">info@mesonera.com</p>
        <p class="mb-2 text-xl font-bold">{{ $t('Phone') }}:</p>
        <p class="mb-4 text-lg">+507 6164 7423</p>
        <p class="mb-2 text-xl font-bold">Whatsapp:</p>
        <p class="mb-4 text-lg">+507 6164 7423</p>

      </div>
    </section>
  </div>
</template>

<script>
import { db, auth } from '@/firebase';

export default {
  name: 'Account',
  data() {
    return {
      isLoading: false,
      restaurantName: '',
      email: '',
      phone: '',
      address: '',
    };
  },
  async created() {
    const restaurant = await db
      .collection('restaurants')
      .doc(this.$store.state.uid)
      .get();

    if (restaurant.exists) {
      const { address, email, name, phone } = restaurant.data();

      this.restaurantName = name;
      this.email = email;
      this.address = address;
      this.phone = phone;
    }
  },
  methods: {
    handleLogout() {
      auth.signOut();
      this.$toasted.success(this.$t('Logged out successfuly!'), {
        theme: 'bubble',
        position: 'top-center',
        duration: 3000,
      });
      this.$router.push('login');
    },
  },
};
</script>
<style lang="scss">
.admin-account-container {
  // height: 98vh;
}
</style>
